import { NodeViewWrapper } from '@tiptap/react';
import type { NodeViewProps } from '@tiptap/react';
import {
  JsonTypeBuilder,
  JSONNode,
} from '@cotera/client/app/components/json-type-builder';
import { Text } from '@cotera/client/app/components/ui/text';

export const JsonTypeBuilderNodeView = ({
  node,
  updateAttributes,
}: NodeViewProps) => {
  const jsonNode = node.attrs['jsonNode'] as JSONNode;

  return (
    <NodeViewWrapper
      className="json-type-builder-node react-renderer mt-4"
      data-drag-handle
    >
      <div
        className="p-2 border rounded-md bg-indigo-100 select-none border-indigo-300 flex flex-col gap-2"
        contentEditable={false}
        suppressContentEditableWarning
      >
        <Text.Label className="text-indigo-500 font-medium">
          Your response should look like...
        </Text.Label>
        <div className="flex flex-col gap-2 w-full bg-background rounded-md p-2 border border-indigo-300 prose-ignore">
          <JsonTypeBuilder
            bordered={false}
            value={jsonNode}
            onChange={(newValue) => {
              updateAttributes({
                jsonNode: newValue,
              });
            }}
          />
        </div>
      </div>
    </NodeViewWrapper>
  );
};
